module.exports = __webpack_public_path__ + "a41d56c1280fd80507071ad8e628c269.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/hygiene_roundel.svg
// module id = 1266
// module chunks = 65